import { sendGAEvent } from '../utils';

export enum EGamesEvents {
  HOT_COLD_GAMES = 'hot_cold_games',
  ERROR_HOT_COLD_GAMES = 'error_hot_cold_games',
  GEOBLOCK_IMPRESSION = 'geoblock_impression',
}

interface IHotAndColdEvent {
  type: 'hot' | 'cold';
  game_name: string;
}

/**
 * @description Sends a Google Analytics event for the 'hot_cold_games' event when a user clicks a demo or real play link in the hot and cold games block. The event is categorized under 'games' and includes the game type ('hot' or 'cold') and game name.
 * @param data - Object containing the event type ('hot' or 'cold') and the game name.
 */

export const sendHotAndColdEvent = (data: IHotAndColdEvent) => {
  sendGAEvent(EGamesEvents.HOT_COLD_GAMES, {
    event_category: 'games',
    ...data,
  });
};

export interface IErrorHotAndColdEvent {
  type: 'no_both' | 'no_hot' | 'no_cold' | 'server_error';
}

/**
 * @description Sends a Google Analytics event for the 'error_hot_cold_games' event.
 * This is triggered when there is an error in loading or displaying hot and cold games.
 * The event includes the error type (e.g., 'no_games' or 'server_error').
 * @param data - Object containing the error type.
 */

export const sendErrorHotAndColdEvent = (data: IErrorHotAndColdEvent) => {
  sendGAEvent(EGamesEvents.ERROR_HOT_COLD_GAMES, {
    event_category: 'games',
    ...data,
  });
};

interface IGeoblockImpressionEvent {
  page_path: string;
  user: 'authorized' | 'unauthorized';
  effective_country: string;
}

/**
 * @description Sends a Google Analytics event for the 'geoblock_impression' event when the
 * geo-blocked screen is shown on a game page. Includes the page path, whether the user is
 * authorized, and the effective country (lowercase ISO code) the block was based on.
 * @param data - Object containing page_path, user authorization status, and effective_country.
 */

export const sendGeoblockImpressionEvent = (data: IGeoblockImpressionEvent) => {
  sendGAEvent(EGamesEvents.GEOBLOCK_IMPRESSION, {
    event_category: 'games',
    ...data,
  });
};
